import React, { useState, useEffect, useMemo } from "react";
import { Link, useParams, useHistory } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  FormGroup,
  Card,
  CardBody,
  Spinner,
  Button,
} from "reactstrap";

// Toast
import toastr from "toastr";
import "toastr/build/toastr.min.css";

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

//Import CustomSelectMulti
import CustomSelectMulti from "../../components/Common/CustomSelectMulti";

//i18n
import { withTranslation } from "react-i18next";

import { useDispatch, useSelector } from "react-redux";

import {
  getRole,
  createRole,
  editRole,
  resetRole,
  resetRoles,
  resetError,
} from "../../store/actions";

const NewRole = ({ t }) => {
  let { idRole } = useParams();
  const dispatch = useDispatch();
  const history = useHistory();

  const {
    dataRoleGetSet,
    dataRoleEditCreate,
    loadingRole,
    loadingRoleEditCreate,
    successRole,
    errorRole,
  } = useSelector((state) => state.Role);

  const [roleValues, setRoleValues] = useState({
    name: "",
    description: "",
    role: "",
    type: "",
  });
  const [newFields, setNewFields] = useState({});
  const [enableSubmit, setEnableSubmit] = useState(false);

  const [textAreaBadge, setTextAreaBadge] = useState(false);
  const [textCount, setTextCount] = useState(false);

  const optionsType = useMemo(
    () => [
      { value: "", label: t("Select"), isDisabled: true },
      { value: "admin", label: t("Admin") },
      { value: "manager", label: t("Manager") },
      { value: "agent", label: t("Agent") },
    ],
    [t]
  );

  const handleCreateEditRole = () => {
    if (idRole) {
      dispatch(editRole(idRole, newFields));
    } else {
      dispatch(createRole(newFields));
    }
  };

  const textAreaChange = (e) => {
    var data = e.target.value;
    var count = data.length;

    if (count > 0) {
      setTextAreaBadge(true);
    } else {
      setTextAreaBadge(false);
    }
    setTextCount(data.length);

    if (data === roleValues.description) {
      delete newFields.description;
      checkSubmit();
    } else {
      setNewFields((previous) => ({
        ...previous,
        description: data,
      }));
    }
  };

  const arrayEquals = (a, b) => {
    return (
      Array.isArray(a) &&
      Array.isArray(b) &&
      a.length === b.length &&
      a.every((val, index) => val === b[index])
    );
  };

  const setPermissions = (values) => {
    //TODO: Add values to State
    let aux1 = [];
    values.options.map((item) =>
      JSON.parse(item.value).permissions.map((item) => aux1.push(item.value))
    );
    let aux2 = [];
    Object.keys(roleValues.role).map((item) =>
      roleValues.role[item].map((item) => aux2.push(item.id))
    );

    if (arrayEquals(aux1, aux2)) {
      delete newFields.permissions_ids;
      checkSubmit();
    } else {
      if (values.options[0]) {
        let parsedPermissions = values.options.map((item) => ({
          key: item.key,
          value: JSON.parse(item.value),
          label: item.label,
        }));

        let aux = [];
        parsedPermissions.map((element) =>
          element.value.permissions.map((item) => aux.push(item.value))
        );

        setNewFields({
          ...newFields,
          permissions_ids: aux,
        });
      } else {
        setNewFields({
          ...newFields,
          permissions_ids: [],
        });
      }
    }
  };

  const showToast = (type, message) => {
    toastr[type](message);
  };
  toastr.options = {
    closeButton: false,
    debug: false,
    newestOnTop: false,
    progressBar: true,
    positionClass: "toast-top-right",
    preventDuplicates: true,
    onclick: null,
    showDuration: "200",
    hideDuration: "200",
    timeOut: "2000",
    extendedTimeOut: "2000",
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut",
    onHidden: () =>
      successRole &&
      dispatch(resetRole()) &&
      dispatch(resetRoles()) &&
      history.push("/roles"),
  };

  const checkSubmit = () => {
    if (Object.keys(newFields).length !== 0) setEnableSubmit(true);
    else setEnableSubmit(false);
  };

  useEffect(() => {
    checkSubmit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newFields]);

  useEffect(() => {
    dispatch(resetRole());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    dispatch(getRole(idRole, true));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idRole]);

  useEffect(() => {
    if (
      idRole &&
      dataRoleGetSet &&
      dataRoleGetSet.data &&
      dataRoleGetSet.data.role
    ) {
      setRoleValues((previous) => ({
        ...previous,
        name: dataRoleGetSet.data.role.name,
        description: dataRoleGetSet.data.role.description,
        role: dataRoleGetSet.data.role.permissions,
        type: dataRoleGetSet.data.role.type,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataRoleGetSet]);

  useEffect(() => {
    if (dataRoleEditCreate && dataRoleEditCreate.message) {
      showToast("success", t(dataRoleEditCreate.message));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [successRole]);

  useEffect(() => {
    if (errorRole && typeof errorRole === "object") {
      errorRole.map((error) => showToast("error", t(error.value)));
      dispatch(resetError());
    } else {
      if (errorRole) {
        showToast("error", t(errorRole));
        dispatch(resetError());
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorRole]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs
            mainPath="/roles"
            path={idRole ? "/role/" + idRole : "/role"}
            title={t("Roles")}
            breadcrumbItem={!idRole ? t("Create role") : t("Edit Role")}
          />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <AvForm onValidSubmit={handleCreateEditRole}>
                    <Row>
                      <Col sm="12">
                        <FormGroup>
                          <AvField
                            label={t("Name") + " *"}
                            id="roleName"
                            name="name"
                            type="text"
                            className="form-control"
                            placeholder={t("Role name")}
                            onChange={(e) => {
                              if (e.target.value === roleValues.name) {
                                delete newFields.name;
                                checkSubmit();
                              } else {
                                setNewFields((previous) => ({
                                  ...previous,
                                  name: e.target.value,
                                }));
                              }
                            }}
                            value={roleValues.name}
                            validate={{
                              required: {
                                value: true,
                                errorMessage: t("Required Field"),
                              },
                              maxLength: {
                                value: 255,
                                errorMessage: t("Invalid field"),
                              },
                            }}
                          />
                        </FormGroup>
                        <FormGroup className="select2-container">
                          <AvField
                            name="type"
                            className="form-control"
                            type="select"
                            label={t("Type") + " *"}
                            options={optionsType}
                            onChange={(e) => {
                              if (
                                e.target.value === roleValues.type
                              ) {
                                delete newFields.type;
                                checkSubmit();
                              } else {
                                setNewFields((previous) => ({
                                  ...previous,
                                  type: e.target.value,
                                }));
                              }
                            }}
                            value={roleValues.type}
                            defalutValue={roleValues.type}
                            validate={{
                              required: {
                                value: true,
                                errorMessage: t("Required Field"),
                              },
                            }}
                          >
                            {optionsType.map((option, key) => (
                              <option
                                key={key}
                                value={option.value}
                                disabled={option.isDisabled}
                              >
                                {option.label}
                              </option>
                            ))}
                          </AvField>
                        </FormGroup>
                        <FormGroup>
                          <CustomSelectMulti
                            title={t("Permissions")}
                            id="permissions"
                            name="permissions"
                            placeholder={t("Select")}
                            isRequired={true}
                            isLoading={loadingRole}
                            objItems={
                              dataRoleGetSet &&
                              dataRoleGetSet.data &&
                              dataRoleGetSet.data.form &&
                              dataRoleGetSet.data.form.permissions
                            }
                            onChange={(e) => setPermissions(e)}
                            value={roleValues.role}
                          />
                        </FormGroup>
                        <FormGroup>
                          <AvField
                            id="roleDescription"
                            name="roleDescription"
                            type="textarea"
                            label={t("Description") + " *"}
                            placeholder={t("Description")}
                            className="form-control"
                            rows="3"
                            value={roleValues.description}
                            onChange={textAreaChange}
                            validate={{
                              required: {
                                value: true,
                                errorMessage: t("Required Field"),
                              },
                              maxLength: {
                                value: 255,
                              },
                              minLength: {
                                value: 10,
                                errorMessage: t(
                                  '"description" length must be at least 10 characters long'
                                ),
                              },
                            }}
                          />
                          {textAreaBadge ? (
                            <span className="badgecount badge badge-success">
                              {" "}
                              {textCount} / 255{" "}
                            </span>
                          ) : null}
                        </FormGroup>
                      </Col>
                    </Row>

                    <Button
                      type="submit"
                      color="primary"
                      className="mr-1 waves-effect waves-light"
                      style={{
                        minWidth: "100px",
                        cursor: enableSubmit ? "pointer" : "no-drop",
                      }}
                      disabled={!enableSubmit}
                    >
                      {loadingRoleEditCreate ? (
                        <Spinner
                          size="sm"
                          animation="border"
                          style={{
                            height: "19px",
                            width: "19px",
                          }}
                        />
                      ) : (
                        t("Confirm")
                      )}
                    </Button>
                    <Link to="/roles">
                      {" "}
                      <Button
                        type="button"
                        color="secondary"
                        className="waves-effect"
                        onClick={() => dispatch(resetRole())}
                      >
                        {t("Cancel")}
                      </Button>
                    </Link>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(NewRole);
